<template>
  <div>
    <v-dialog v-model="modalAberto" transition="dialog-bottom-transition" max-width="1200">
      <div class="sala-espera-modal">
        <div class="modal-header">
          <div class="header-content">
            <div class="header-left">
              <div class="header-icon">
                <v-icon>mdi-sofa-single</v-icon>
              </div>
              <div class="header-text">
                <h2 class="header-title">Sala de Espera</h2>
                <p class="header-subtitle">{{ descricaoAgenda }}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="unified-content">
          <v-card class="unified-card" :loading="realizandoRemocao ? 'success' : null" :disabled="realizandoRemocao">
            <div class="table-content">
              <v-data-table v-model="linhaSelecionada" :loading="carregando ? 'success' : null" show-select
                single-select no-data-text="Nenhum paciente na sala de espera!"
                loading-text="Buscando pacientes na sala de espera..." :items="pacientesDaSalaDeEspera"
                :headers="colunas" :footer-props="{
                  'itemsPerPageOptions': [3, 5, 10, 15],
                  'itemsPerPageText': 'Pacientes por página',
                  'pageText': '{0}-{1} de {2}'
                }">
                <template v-slot:item.agendamentoConsulta.convenio.nome ="{ value }">
                  {{ value ? value : 'Particular' }}
                </template>
                <template v-slot:item.agendamentoConsulta.paciente.nomeSocial="{ value }">
                  {{ value ? value : 'Não informado' }}
                </template>

                <template v-slot:item.espera="{ item }">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <b v-bind="attrs" v-on="on" class="espera-text">
                        {{ item.espera }}
                      </b>
                    </template>
                    <span>
                      Tempo decorrido desde a chegada do paciente até o momento atual.
                    </span>
                  </v-tooltip>
                </template>
                <template v-slot:item.agendamentoConsulta.horaChegada="{ item }">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <a v-bind="attrs" v-on="on" class="chegada-text">
                        {{ formataHora(item.agendamentoConsulta.horaChegada) }}
                      </a>
                    </template>
                    <span>
                      Horário em que o paciente foi registrado na sala de espera.
                    </span>
                  </v-tooltip>
                </template>
                <template v-slot:item.observacaoAgendamento="{ item }">
                  <div class="ml-4">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <span v-bind="attrs" v-on="on">
                          <v-icon :color="item.observacaoAgendamento ? 'success' : 'grey'" medium
                            :class="item.observacaoAgendamento ? 'pulse' : ''">mdi-eye-outline</v-icon>
                        </span>
                      </template>
                      <div v-if="item.observacaoAgendamento" class="tooltip-break">
                        {{ item.observacaoAgendamento }}
                      </div>
                      <div v-else class="tooltip-break">
                        Nenhuma observação no momento.
                      </div>
                    </v-tooltip>
                  </div>
                </template>
              </v-data-table>
            </div>
            <div class="form-actions">
              <div class="actions-container">
                <v-btn class="action-btn cancel-btn" :class="'warning'" @click="fecharModal()">
                  <v-icon left>mdi-keyboard-return</v-icon>
                  Voltar
                </v-btn>
                <v-btn class="action-btn remove-btn" :loading="realizandoRemocao"
                  :disabled="linhaSelecionada.length > 0 ? false : true" @click="abrirModalRemoverPaciente()">
                  <v-icon left>mdi-minus</v-icon>
                  Remover
                </v-btn>
                <v-btn v-if="possuiPermissaoCriarAtendimento" class="action-btn attend-btn"
                  :disabled="linhaSelecionada.length > 0 ? false : true" @click="atender()">
                  <v-icon left>mdi-stethoscope</v-icon>
                  Atender
                </v-btn>
              </div>
            </div>
          </v-card>
        </div>
      </div>
    </v-dialog>
    <v-dialog v-model="modalRemoverPaciente" max-width="600">
      <div class="remover-paciente-modal">
        <div class="modal-header">
          <div class="header-content">
            <div class="header-left">
              <div class="header-icon">
                <v-icon>mdi-account-remove</v-icon>
              </div>
              <div class="header-text">
                <h2 class="header-title">Remover Paciente</h2>
                <p class="header-subtitle">{{ agendamentoARemover.agendamentoConsulta?.paciente?.nomeCompleto }} da sala
                  de
                  espera?</p>
              </div>
            </div>
          </div>
        </div>
        <div class="unified-content">
          <v-card class="unified-card">
            <div class="form-content">
              <h4 class="section-title">Situação do agendamento:</h4>
              <v-menu bottom right>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn height="48" block outlined class="modern-select" v-bind="attrs" v-on="on">
                    <v-icon left dense :color="corDaSituacaoAgendamento(situacaoAgendamento)">
                      {{ iconeDaSituacaoAgendamento(situacaoAgendamento) }}
                    </v-icon>
                    <span :style="`color: ${corDaSituacaoAgendamento(situacaoAgendamento)}`">
                      {{ textDaSituacaoAgendamento(situacaoAgendamento) }}
                    </span>
                    <v-icon right>mdi-menu-down</v-icon>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item v-for="item in opcoesSituacaoAgendamento" :key="item.value"
                    @click="situacaoAgendamento = item.value">
                    <v-list-item-title>
                      <v-icon :color="item.color" left dense>{{ item.icon }}</v-icon>
                      <span :style="`color: ${item.color}`">{{ ' ' + item.text }}</span>
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </div>
            <div class="form-actions">
              <div class="actions-container">
                <v-btn class="action-btn cancel-btn" :class="'warning'" @click="modalRemoverPaciente = false">
                  <v-icon left>mdi-keyboard-return</v-icon>
                  Cancelar
                </v-btn>
                <v-btn class="action-btn remove-btn" :loading="realizandoRemocao"
                  @click="removerAgendamentoDaSalaDeEspera()">
                  <v-icon left>mdi-minus</v-icon>
                  Remover
                </v-btn>
              </div>
            </div>
          </v-card>
        </div>
      </div>
    </v-dialog>
    <ModalAtendimentosNaoFinalizados ref="modalAtendimentosNaoFinalizados"></ModalAtendimentosNaoFinalizados>
    <modal-editar-paciente ref="modalEditarPaciente" />
  </div>
</template>

<script lang="ts">
import Vue from 'vue';
import DateHelper from '../../helpers/DateHelper';
import { AlertaSimplesErro } from '../../helpers/MensagemHelper';
import { CadastroCompletoHelper } from '../../helpers/CadastroCompletoHelper';
import { AgendamentoService } from '../../services/AgendamentoService';
import { PacientesService } from '../../services/PacientesService';
import Agendamento from '../../models/agendamento/Agendamento';
import { SituacaoAgendamento } from '../../models/enums/EnumSituacaoAgendamento';
import ModalAtendimentosNaoFinalizados from '../../views/atendimento/ModalAtendimentosNaoFinalizados.vue';
import ModalEditarPaciente from '../paciente/ModalEditarPaciente.vue';
import { getToken, getUserPermissions } from '@/utils/Token';

export default Vue.extend({
  components: {
    ModalAtendimentosNaoFinalizados,
    ModalEditarPaciente,
  },
  name: 'soi-sala-de-espera',
  mounted() {
    this.atualizaListaPacientesNaSalaDeEspera();
    this.contadorTempoDeEspera();
  },
  data() {
    return {
      agendamento: new Agendamento(),
      agendamentoARemover: new Agendamento(),
      carregando: true,
      descricaoAgenda: '',
      realizandoRemocao: false,
      serviceAgendamento: new AgendamentoService(),
      servicePaciente: new PacientesService(),
      modalAberto: false,
      modalRemoverPaciente: false,
      situacaoAgendamento: 0,
      linhaSelecionada: [],
      pacientesDaSalaDeEspera: [],
      agendaId: 0,
      colunas: [
        {
          value: 'horaAgendamento',
          text: 'Hora',
        },
        {
          value: 'agendamentoConsulta.horaChegada',
          text: 'Chegada',
        },
        {
          value: 'espera',
          text: 'Espera',
          textvariant: 'danger',
        },
        {
          value: 'agendamentoConsulta.paciente.nomeCompleto',
          text: 'Paciente',
        },
        {
          value: 'agendamentoConsulta.convenio.nome',
          text: 'Convênio',
        },

        {
          value: 'agendamentoConsulta.paciente.nomeSocial',
          text: 'Nome Social',
        },
        {
          value: 'observacaoAgendamento',
          text: 'Observação',
        },
      ],
      opcoesSituacaoAgendamento: [
        {
          value: 0,
          text: 'Marcado',
          icon: 'mdi-calendar-check',
          color: '#84b6f4',
        },
        {
          value: 3,
          text: 'Faltou',
          icon: 'mdi-close-octagon-outline',
          color: '#ff6961',
        },
        {
          value: 5,
          text: 'Cancelado',
          icon: 'mdi-cancel',
          color: '#ffe180',
        },
      ],
    };
  },
  computed: {
    possuiPermissaoCriarAtendimento() {
      return getUserPermissions(getToken()).includes('AtendimentoCreate');
    },
  },
  methods: {
    selecionarLinha(items: any) {
      this.linhaSelecionada = items;
    },
    fecharModal() {
      this.modalAberto = false;
    },
    async abrirModal(agendaId: number, descricaoAgenda: string) {
      this.descricaoAgenda = descricaoAgenda;
      this.agendaId = agendaId;
      this.linhaSelecionada = [];
      this.pacientesDaSalaDeEspera = [];
      this.modalAberto = true;
      await this.preencheLista();
    },
    async preencheLista() {
      this.pacientesDaSalaDeEspera = [];
      this.carregando = true;
      await this.serviceAgendamento.GetSalaDeEsperaPorAgenda(this.agendaId).then(
        (res) => {
          this.pacientesDaSalaDeEspera = res.data;
          this.atualizaListaPacientesNaSalaDeEspera();
        },
        (err) => {
          AlertaSimplesErro('Houve um problema ao buscar a sala de espera', err);
          this.modalAberto = false;
        },
      );
      this.carregando = false;
    },
    contadorTempoDeEspera() {
      const timer = setInterval(() => {
        this.atualizaListaPacientesNaSalaDeEspera();
      }, 1000);
    },
    atualizaListaPacientesNaSalaDeEspera() {
      const lista = this.pacientesDaSalaDeEspera;
      this.pacientesDaSalaDeEspera = [];
      lista.forEach((x) => {
        // eslint-disable-next-line no-param-reassign
        x.espera = DateHelper.tempoRelativo(x.agendamentoConsulta.horaChegada);
      });
      this.pacientesDaSalaDeEspera = lista;
    },
    formataHora(data: any) {
      return DateHelper.formataParaHoraMinutoSegundo(data);
    },
    abrirModalRemoverPaciente() {
      if (this.linhaSelecionada.length > 0) {
        this.situacaoAgendamento = 0;
        const [agendamentoARemover] = this.linhaSelecionada;
        this.agendamentoARemover = agendamentoARemover;
        this.modalRemoverPaciente = true;
      }
    },
    async removerAgendamentoDaSalaDeEspera() {
      this.realizandoRemocao = true;
      await this.serviceAgendamento.atualizaSituacaoAgendamento(this.agendamentoARemover.id, this.situacaoAgendamento).then(
        (res) => { },
        (err) => {
          AlertaSimplesErro('Não foi possível remover este agendamento da sala de espera!', err);
        },
      );
      this.realizandoRemocao = false;
      this.$emit('atualizaCalendario');
      this.linhaSelecionada = [];
      this.modalRemoverPaciente = false;
      this.preencheLista();
    },
    async atender() {
      if (this.linhaSelecionada.length > 0) {
        const [agendamento] = this.linhaSelecionada;
        this.agendamento = agendamento;
        const pacienteId = this.agendamento.agendamentoConsulta?.pacienteId;
        if (pacienteId) {
          try {
            const pacienteResponse = await this.servicePaciente.ObterDadosDoPaciente(pacienteId);
            const paciente = pacienteResponse.data;

            const podeProsseguir = await CadastroCompletoHelper.validarCadastroCompleto(
              pacienteId,
              paciente.cadastroCompleto,
              (id: number) => {
                (this.$refs.modalEditarPaciente as any).abrirModal(id);
              },
            );

            if (!podeProsseguir) {
              return;
            }
          } catch (error) {
            AlertaSimplesErro('Erro ao validar cadastro:', error);
            return;
          }
        }

        this.$refs.modalAtendimentosNaoFinalizados.abrirModalAtendimentosNaoFinalizadosSalaDeEspera(
          this.agendamento,
          { origemSalaDeEspera: true },
        );
      }
    },
    // #region <Funções do componente de Situação do Agendamento>
    corDaSituacaoAgendamento(situacaoAgendamento: SituacaoAgendamento) {
      return this.opcoesSituacaoAgendamento.find(
        (x) => x.value === situacaoAgendamento,
      )!.color;
    },
    iconeDaSituacaoAgendamento(situacaoAgendamento: SituacaoAgendamento) {
      return this.opcoesSituacaoAgendamento.find(
        (x) => x.value === situacaoAgendamento,
      )!.icon;
    },
    textDaSituacaoAgendamento(situacaoAgendamento: SituacaoAgendamento) {
      return this.opcoesSituacaoAgendamento.find(
        (x) => x.value === situacaoAgendamento,
      )!.text;
    },
    // #endregion
  },
});
</script>

<style scoped>
/* === MODAL PRINCIPAL === */
.sala-espera-modal {
  background: white;
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);
}

.modal-header {
  background: var(--especialidade-primary, #2e4b9d);
  color: white;
  padding: 24px 32px;
  position: relative;
}

.header-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.header-left {
  display: flex;
  align-items: center;
  gap: 16px;
}

.header-icon {
  width: 48px;
  height: 48px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
}

.header-text {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.header-title {
  font-size: 24px;
  font-weight: 700;
  margin: 0;
  color: white;
}

.header-subtitle {
  font-size: 14px;
  margin: 0;
  color: rgba(255, 255, 255, 0.8);
}

/* === CONTEÚDO UNIFICADO === */
.unified-content {
  padding: 32px;
}

.unified-card {
  border-radius: 16px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(0, 0, 0, 0.05);
}

.table-content {
  padding: 24px;
}

/* === AÇÕES === */
.form-actions {
  padding: 24px 32px;
  background: #f8f9fa;
  border-top: 1px solid rgba(0, 0, 0, 0.05);
}

.actions-container {
  display: flex;
  gap: 12px;
  justify-content: flex-end;
}

.action-btn {
  border-radius: 12px !important;
  text-transform: none !important;
  font-weight: 600 !important;
  padding: 0 24px !important;
  height: 48px !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;
  transition: all 0.3s ease !important;
}

.action-btn:hover {
  transform: translateY(-2px) !important;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.2) !important;
}

.cancel-btn .v-icon {
  color: #ffffff !important;
}

.cancel-btn:hover {
  background: var(--especialidade-gradient, #2e4b9d) !important;
  color: #ffffff !important;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.remove-btn {
  background: #dc3545 !important;
  color: white !important;
}

.remove-btn:hover {
  background: #c82333 !important;
}

.remove-btn:disabled {
  background: #e9ecef !important;
  color: #6c757d !important;
  box-shadow: none !important;
  transform: none !important;
}

.attend-btn {
  background: var(--especialidade-primary, #2e4b9d) !important;
  color: white !important;
}

.attend-btn:hover {
  background: var(--especialidade-secondary, #4a6cf7) !important;
}

.attend-btn:disabled {
  background: #e9ecef !important;
  color: #6c757d !important;
  box-shadow: none !important;
  transform: none !important;
}

/* === MODAL REMOVER PACIENTE === */
.remover-paciente-modal {
  background: white;
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);
}

.remover-paciente-modal .modal-header {
  background: #dc3545;
}

.remover-paciente-modal .unified-content {
  padding: 32px;
}

.remover-paciente-modal .form-content {
  padding: 24px;
}

.section-title {
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 16px;
  color: #495057;
}

.modern-select {
  border-radius: 12px !important;
  border: 2px solid #e9ecef !important;
  transition: all 0.3s ease !important;
}

.modern-select:hover {
  border-color: var(--especialidade-primary, #2e4b9d) !important;
}

/* === RESPONSIVIDADE === */
@media (max-width: 768px) {

  .sala-espera-modal,
  .remover-paciente-modal {
    margin: 16px;
    border-radius: 16px;
  }

  .modal-header {
    padding: 20px 24px;
  }

  .header-title {
    font-size: 20px;
  }

  .unified-content {
    padding: 24px;
  }

  .table-content {
    padding: 16px;
  }

  .form-actions {
    padding: 20px 24px;
  }

  .actions-container {
    flex-direction: column;
    gap: 8px;
  }

  .action-btn {
    width: 100%;
  }
}

/* === ESTILOS ORIGINAIS === */
.pulse {
  animation: pulse-animation 1.2s infinite;
}

@keyframes pulse-animation {
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(1.10);
  }

  100% {
    transform: scale(1);
  }
}

.espera-text {
  color: red;
  font-weight: bold;
}

.chegada-text {
  color: #2ecc71;
}

.tooltip-break {
  white-space: pre-line;
  max-width: 350px;
  word-break: break-word;
}
</style>
